import { apiGet } from '@/shared/utils/requestBuilder';
import type { ActiveProduct } from '../../types/activeProduct';

export interface CheckActiveResult {
  hasActive: boolean;
  contractId: string | null;
}

export const activeProductsService = {
  async fetchActive(): Promise<ActiveProduct[]> {
    const response = await apiGet('/products/active');
    const json = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(json?.error?.message || 'Failed to fetch active products');
    }

    return json.data as ActiveProduct[];
  },

  async checkActiveContract(productId: string, workspaceId: string): Promise<CheckActiveResult> {
    const response = await apiGet('/products/contracts/check-active', { productId, workspaceId });
    const json = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(json?.error?.message || 'Failed to check active contract');
    }

    return json.data as CheckActiveResult;
  },
};
